import { gql, useMutation } from '@apollo/client';
import { notification } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GET_SPECIFIC_BOARDER_UPDATE_GENERAL_INFO_REQUESTS } from 'src/gql/queries';
import { DecideAboutBoarderUpdateGeneralInfoRequestInput } from 'src/shared/types/api';
import { UseOnMutation } from '..';

export const APPROVE_UPDATE_BOARDER_GENERAL_INFO_REQUEST = gql`
  mutation ApproveUpdateBoarderGeneralInfoRequest($input: DecideAboutUpdateBoarderGeneralInfoRequestInput!) {
    approveUpdateBoarderGeneralInfoRequest(input: $input) {
      boarderId
    }
  }
`;

type UseApproveUpdateBoarderGeneralInfoRequestArgs =
  Omit<DecideAboutBoarderUpdateGeneralInfoRequestInput, 'boarderId'> & {
    boarderId?: string;
    onComplete?: () => void;
  };

export const useApproveUpdateBoarderGeneralInfoRequest = (
  { boarderId, requestId, onComplete }: UseApproveUpdateBoarderGeneralInfoRequestArgs,
): UseOnMutation => {
  const { t } = useTranslation();
  const [approveUpdateBoarderGeneralInfoRequest, { loading }] = useMutation<
    unknown, { input: DecideAboutBoarderUpdateGeneralInfoRequestInput }
  >(
    APPROVE_UPDATE_BOARDER_GENERAL_INFO_REQUEST,
    { refetchQueries: [GET_SPECIFIC_BOARDER_UPDATE_GENERAL_INFO_REQUESTS] },
  );

  const onApproveUpdateBoarderGeneralInfoRequest = useCallback(async () => {
    if (!boarderId) {
      return notification.error({ message: t('Boarder update boarder general info request has not been approved successfully') });
    }
    try {
      await approveUpdateBoarderGeneralInfoRequest({
        variables: {
          input: {
            boarderId,
            requestId,
          },
        },
      });

      return notification.success({ message: t('Boarder update boarder general info request has been approved successfully') });
    } catch (error) {
      return notification.error({ message: t('Boarder update boarder general info request has not been approved successfully') });
    } finally {
      onComplete?.();
    }
  }, [boarderId, requestId, onComplete]);

  return [onApproveUpdateBoarderGeneralInfoRequest, loading];
};
